import { Button, Flex, Modal, Upload, Spin } from "antd";
import React from "react";
import { CustomTitle } from "../../../../../common/customTitle";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fileDocumentUploadAction } from "../../../../../../redux/services/auth/authServices";
import { PaperClipOutlined } from "@ant-design/icons";
import { toastService } from "../../../../../common/toast-messages/toast";
import { uploadServiceProviderAppointmentCustomerDocumentsAction } from "../../../../../../redux/services/service-provider-appointments/serviceProviderAppointmentsServices";
import { useTranslation } from "react-i18next";
import { checkIfFileTypeIsValidForPdfAttachment, downloadUrl, formulateAttachmentPreview, readImageFileAsync } from "../../../../../../utils/utils";

const DocumentsDialog = ({ orderId, onClose }) => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* module dependencies for attachment - multiple */
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [previewImageSrc, setPreviewImageSrc] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [multipleAttachmentList, setMultipleAttachmentList] = useState([]);
  /* module dependencies for attachment - multiple */

  /* open image preview for dialog - multiple attachment */
  const handleAttachmentPreview = async (file) => {
    const formulateAttachment = await formulateAttachmentPreview(file,file?.name,file.url);
    if(!formulateAttachment?.isFileTypeImage){
      downloadUrl(formulateAttachment?.fileImagePreview)
    }
    else {
      if (!file.url && !file.preview) {
        file.preview = await readImageFileAsync(file.originFileObj);
      }
      setPreviewImageSrc(file?.url || file?.preview);
      setOpenPreviewDialog(true);
      const tempPreviewTitle = file?.name || file?.url?.substring(file?.url?.lastIndexOf("/") + 1);
      setPreviewTitle(tempPreviewTitle);
    }
  };
  /* open image preview for dialog - multiple attachment */

  const handleClose = () => {
    onClose(orderId);
    setMultipleAttachmentList([]);
  };

  /* perform delete action */
  const onSubmit = () => {
    if (
      !multipleAttachmentList ||
      multipleAttachmentList === undefined ||
      multipleAttachmentList === null ||
      multipleAttachmentList.length === 0
    ) {
      toastService.error(t("CommonUtils.pleaseUploadADocument"));
      return;
    }

    const dataToBeSent = {
      documents: multipleAttachmentList?.map((element) => ({
        url: element?.response?.documentUrl,
        name: element?.response?.name,
      })),
      orderId,
    };

    dispatch(
      uploadServiceProviderAppointmentCustomerDocumentsAction(
        dataToBeSent,
        setLoading
      )
    ).then(() => {
      handleClose(orderId);
    });
  };
  /* perform delete action */

  return (
    <Flex vertical gap="1rem" align="center" justify="center">
      <CustomTitle
        fontSize="md"
        textDecoration="underline"
        justifyContent="center"
      >
        {t("CommonUtils.document")}
      </CustomTitle>
      {loading ? (
        <Spin />
      ) : (
        <>
          <Flex vertical align="center" justify="center">
            <Upload
              accept=".pdf"
              listType="picture-card"
              fileList={multipleAttachmentList}
              onPreview={handleAttachmentPreview}
              onChange={(options) => {

                const attachmentFileName = options.file.name;
                const fileTypeIsValidRes = checkIfFileTypeIsValidForPdfAttachment(attachmentFileName);

                if (fileTypeIsValidRes.isValid === false) {
                  toastService.error(fileTypeIsValidRes.isInvalidMessage);
                } else {
                  setMultipleAttachmentList(options.fileList);
                }
              }}
              onRemove={(file) =>
                setMultipleAttachmentList(
                  multipleAttachmentList?.filter(
                    (element) => element.uid !== file.uid
                  )
                )
              }
              customRequest={(options) => {
                const attachmentFileName = options.file.name;
                const fileTypeIsValidRes = checkIfFileTypeIsValidForPdfAttachment(attachmentFileName);

                if (fileTypeIsValidRes.isValid === false) {
                  toastService.error(fileTypeIsValidRes.isInvalidMessage);
                } else {
                  const formData = new FormData();
                formData.append("document", options.file);
                dispatch(fileDocumentUploadAction(formData)).then((apiRes) => {
                  const document = apiRes?.[0];
                  options.file["url"] = document?.documentUrl;
                  options.onSuccess(document, options.file);
                });
                }
              }}
              className="uploadContainer"
              maxCount={1}
            >
              {multipleAttachmentList?.length >= 1 ? null : (
                <Button
                  type="primary"
                  shape="circle"
                  size="middle"
                  icon={<PaperClipOutlined />}
                />
              )}
            </Upload>
            <Modal
              open={openPreviewDialog}
              title={previewTitle}
              footer={null}
              onCancel={() => setOpenPreviewDialog(false)}
            >
              <img style={{ width: "100%" }} src={previewImageSrc} />
            </Modal>
          </Flex>
          <Button type="primary" size="small" onClick={onSubmit}>
            {t("CommonUtils.submit")}
          </Button>
        </>
      )}
    </Flex>
  );
};

export default DocumentsDialog;
